import React, { Component } from 'react';
import {unitApp} from './unitApp'

import imageInfo from '../../../assets/img/info.png';
import './QuestionLDC.css';

//Semantic
import 'semantic-ui-css/semantic.min.css';
import {
  Popup,
  Image,
  Dropdown,
  Label,
	Grid,
	Segment
} from 'semantic-ui-react';

import { translate } from "react-translate";
import { connect } from "react-redux";

import API from '../../../services/api';
import OwlCarousel from 'react-owl-carousel';


const mapStateToProps = state => ({
  app: state.app
});


class ConnectedQuestionLDC extends Component{
  constructor(props) {
    super(props)

    this.state = {
      cur: this.props.currency,
      selectedValue: this.props.preentry,
			operandID: this.props.operandID,
			groupid: this.props.groupid,
			order: this.props.order,
			text: this.props.text,
			unitApp: unitApp,
      picture: null,
			variableText: this.props.variableText,
			variable: this.props.variableNum,
			variableNum: this.props.variableNum,
			textchoose: '',
			raz: this.props.raz,
			unit: this.props.unit,
			userUnit: this.props.userUnit,
			lang: this.props.lang,
			img: null,
			error: this.props.error,
			questionLdcOptions: this.createQuestionLdcOptions(),
    }

		this.handleDropDownChange = this.handleDropDownChange.bind(this);
  }

	componentWillMount() {
		let questionLdcOptions = this.createQuestionLdcOptions()
		this.updateQuestionLdcData(questionLdcOptions, this.props.preentry)
		this.setState({
			questionLdcOptions: questionLdcOptions
		})
	}

  componentWillReceiveProps(nextProps) {
    if (this.props != nextProps) {
      //RAZ
      if (this.props.raz != nextProps.raz) {

        if (nextProps.preentry === undefined) {
          this.setState({
            selectedValue: "",
						error: nextProps.error
          })
        } else {
          this.setState({
            selectedValue: nextProps.preentry,
						error: nextProps.error
          })
        }
				this.updateQuestionLdcData(this.state.questionLdcOptions, this.props.preentry)
      } else { //CALCUL
        this.setState({
					error: nextProps.error
        })
      }
    }
	}
	
	componentDidUpdate(prevProps) {
		if (JSON.stringify(this.props.options) !== JSON.stringify(prevProps.options)) {
			let questionLdcOptions = this.createQuestionLdcOptions()

			let selectedValue = this.findQuestionLdcOptionByValue(questionLdcOptions, this.state.selectedValue) > 0 ? this.state.selectedValue : 0
			
			selectedValue = selectedValue.toString()
			
			this.updateQuestionLdcData(questionLdcOptions, selectedValue)

			this.setState({
				questionLdcOptions: questionLdcOptions,
				selectedValue: selectedValue,
				textchoose: questionLdcOptions[parseInt(selectedValue)],
			})
		}
	}

	createQuestionLdcOptions() {
		const { t } = this.props;
		let questionLdcOptions = []

		if (this.props.options != undefined ) {
      Object.entries(this.props.options).map((key, Mainindex) => {
        let objet = {}
        let text, picture, filterBool;
        let id = key[1].LDCId;
        let filter = key[1].Filter;

        Object.entries(key[1]).map((key, Mainindex) => {
          if (key[0] === "TextLDC") {
            Object.entries(key[1]).map((key, Mainindex) => {
              if (key[0] === this.props.lang) {
                text = key[1]
              }
            })
          }
        })

        if (key[1].Picture != undefined) {
          picture = key[1].Picture
        }

        // SI filter === imp && UserUnit != Meter -- On affiche
        // SI filter === met && UserUnit === Meter -- On affiche
        // SI filter === both -- On Affiche
        // SINON on affiche pas
        if (filter === "imp" && this.props.userUnit != "Meter") {
          filterBool = true
        } else if (filter === "met" && this.props.userUnit === "Meter") {
          filterBool = true
        } else if (filter === "both") {
          filterBool = true
        } else if (filter === undefined) {
          filterBool = true
        } else {
          filterBool = false
        }

				if (filterBool) {
					let questionLdcOption = {}
					// key={Mainindex} text={text}
					// 	variablenum={key[1].VariableNum} value={id}
					if (Mainindex === 0) {
						let nonQuestionLdcOption = {
							text: t('choisir'),
							value: '0',
							key: 0,
							variablenum: null,
							image: null
						}
						questionLdcOptions.push(nonQuestionLdcOption)
					}
					// Created options data for select tag
					questionLdcOption = {
						text: text,
						value: id,
						key: Mainindex + 1,
						variablenum: key[1].VariableNum,
						image: null
					}

					// Add image into option item
					if (picture !== undefined) {
						questionLdcOption['image'] = {
							avatar: true,
							src: this.makeImagePath(picture)
						}
					}

					questionLdcOptions.push(questionLdcOption)
				}

      })
    }

		return questionLdcOptions
	}

	updateQuestionLdcData(questionLdcOptions, selectedValue) {
		let variableNumValue
		let key = this.findQuestionLdcOptionByValue(questionLdcOptions, selectedValue)
		let variableNum = questionLdcOptions[key] === undefined
											? '' : questionLdcOptions[key].variablenum

		if (variableNum === '' || variableNum === null) {
			variableNumValue = 0
		} else {
			if (variableNum.indexOf(',') >- 1) {
				variableNumValue = parseFloat(variableNum.replace(',', '.'))
			} else {
				variableNumValue = parseInt(variableNum)
			}
			variableNumValue = isNaN(variableNumValue) ? 0 : variableNumValue
		}

		let ldcValue = {
			value: selectedValue,
			variableNum: this.state.variableNum,
			variableText: this.state.variableText,
			variableNumValue: variableNumValue,
			order: this.state.order,
			variableTextValue: selectedValue,
			unitApp: this.state.unit,
			text: this.state.text,
			textChoose: questionLdcOptions[key] == undefined
									? '' : questionLdcOptions[key].text
		}

		this.props.onChangeValueCallback(this.props.groupid, this.props.operandID,
																		 this.props.order, ldcValue)
	}

	makeImagePath(imageName) {
		return API.resourceURL + '/upload/iconsldc/' + (this.props.pro ? imageName : ('product_' + imageName));
	}

	findQuestionLdcOptionByValue(questionLdcOptions, value) {
		// Find questionLDC matching to value
		let key = 0
		for (let i = 0; i < questionLdcOptions.length; i ++) {
			if (questionLdcOptions[i].value === value) {
				key = i
				break
			}
		}
		return key
	}

	handleDropDownChange(e, {value}) {
		let picture = null

		// Find questionLDC matching to value
		let key = this.findQuestionLdcOptionByValue(this.state.questionLdcOptions, value)

		if (value !== 0 && value !== null &&
				this.state.questionLdcOptions[key].image !== null) {
			picture = this.state.questionLdcOptions[key].image.src
		}

		this.updateQuestionLdcData(this.state.questionLdcOptions, value)

    if (picture !== null || picture !== undefined) {
      this.setState({
        loop: 1,
        selectedValue: value,
        img: picture,
				textchoose: this.state.questionLdcOptions[key].text
      });
    } else {
      this.setState({
        loop: 1,
        selectedValue: value,
				img: null,
				textchoose: this.state.questionLdcOptions[key].text
      });
		}

		let isPicture = this.props.type === "picture";
		if(isPicture) {
			setTimeout(() => {
				this.forceUpdate();
			}, 10);
		}
	}
	
	createCarouselLDC() {
		let carou = [];
		for(let option of this.state.questionLdcOptions) {
			if(option.variablenum && option.image) {
				carou.push(option);
			}
		}
		return (
			<Segment raised>
				<OwlCarousel
					className="owl-theme-LDC"
					items={carou.length}
					dots={false}
					margin={30}
					autoWidth
				>
				{
						carou.map((x, i) => {
								return (
										<div key={i} className="item">
													<div className="single-testimonial">
															<div 
																onClick = {(e) => {this.handleDropDownChange(e, {value: x.value}); }}
																className={x.value == this.state.selectedValue ? "ldc-carousel-wrapper selected" : "ldc-carousel-wrapper"}
															>
																	<div className="ldc-carousel-img">
																			<Image
																			centered
																			src={x.image.src}/>
																	</div>
																	<div>
																			<div className="iconLDCTitle">
																				<h4>{x.text}</h4>
																			</div>
																	</div>
															</div>
														</div>
										</div>
								)
						})
				}
				</OwlCarousel>
			</Segment>
		)
	}

	createSelectTagWithSemtanticUIMode(placeholder) {
		if (this.state.img !== null &&
				(this.state.selectedValue !== '0' && this.state.selectedValue !== '')) {
			const trigger = (
			  <span>
			    <Image avatar src={this.state.img}/>
					{this.state.questionLdcOptions[this.state.selectedValue].text}
			  </span>
			)

			return (
				<Dropdown fluid selection className="question-ldc-select-with-image"
					placholder={placeholder}
					options={this.state.questionLdcOptions}
					onChange={this.handleDropDownChange}
					order={this.state.order}
					groupid={this.state.groupid}
					orgtext={this.state.text}
					value={this.state.selectedValue}
					variable={this.state.variableNum}
					variabletext={this.state.variableText}
					variablenum={this.state.variableNum}
					unitapp={this.state.unit}
					trigger={trigger}
				/>
			)
		} else {
			return (
				<Dropdown fluid selection className="question-ldc-select"
					placeholder={placeholder}
					options={this.state.questionLdcOptions}
					onChange={this.handleDropDownChange}
					order={this.state.order}
					groupid={this.state.groupid}
					orgtext={this.state.text}
					value={this.state.selectedValue}
					variabletext={this.state.variableText}
					variable={this.state.variableNum}
					variablenum={this.state.variableNum}
					unitapp={this.state.unit}
				/>
			)
		}
	}


  render() {
		const { t } = this.props;

    let unitTmp;
    if (this.props.unit != undefined) {
      unitTmp = this.props.unit.replace(new RegExp("%%", 'g'), '').split(';')
		}

		let isPicture = this.props.type === "picture";


		return (
      <Grid columns='equal' style={this.props.isHidden ? {display: 'none'} : null}>

        <Grid.Column textAlign={isPicture ? "center" : "left"} verticalAlign="middle" mobile ={isPicture ? 16 : 8} tablet={isPicture ? 16 : 7} computer={isPicture ? 16 : 7}>
          <Label title={this.props.information}
						className={this.props.error ? 'error_title' : 'title'}>
            {this.props.text}
          </Label>

          <Label style={{padding: '0px', fontSize: '0.75rem', backgroundColor: 'transparent'}}>
            {this.props.information != undefined ? (
             	<Popup
                id="popupInfos"
                content={this.props.information}
               	trigger={
									<Image src={imageInfo} size='mini' verticalAlign='middle'
										style={{height: '20px', width: '20px'}} />
               	}
             	/>
           	) : (
              <div></div>
            )}
          </Label>
        </Grid.Column>
						
        <Grid.Column verticalAlign="middle" mobile ={isPicture? 16 : 8} tablet={isPicture? 16 : 9} computer={isPicture? 16 : 9} className='ldc-selector'>
					{
						isPicture? this.createCarouselLDC()  : this.createSelectTagWithSemtanticUIMode(t('choisir'))
					}
        </Grid.Column>
        {
          unitTmp === undefined ? (
            <div></div>
          ):(
            unitTmp[0] === "cur" ? (
              <label>{this.state.cur}</label>
            ):(
              <div></div>
            )
          )
        }

      </Grid>
    )
  }
}

const QuestionLDC = connect(mapStateToProps)(ConnectedQuestionLDC)
export default translate("QuestionLDC")(QuestionLDC);



// WEBPACK FOOTER //
// ./src/components/Protected/Travaux/QuestionLDC.jsx